"use strict";

var CramFile = require('./cramFile');

var IndexedCramFile = require('./indexedCramFile');

var CraiIndex = require('./craiIndex');

module.exports = {
  CramFile: CramFile,
  IndexedCramFile: IndexedCramFile,
  CraiIndex: CraiIndex
};